import styled from 'styled-components'

export default styled.main`
	display: flex;
	justify-content: center;
	height: 100%;
	width: 100%;

	.loading-more-spinner, .load-more-button {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 32px 0;
	}
`